import { render, staticRenderFns } from "./index.vue?vue&type=template&id=28edbb90&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28edbb90')) {
      api.createRecord('28edbb90', component.options)
    } else {
      api.reload('28edbb90', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=28edbb90&", function () {
      api.rerender('28edbb90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MultilineInput/index.vue"
export default component.exports